import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 2H1v16h9v2H8v2h8v-2h-2v-2h9V2zm-2 14H3V4h18v12z"
}), 'DesktopWindowsSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DesktopWindowsSharp.js
// module id = 3111
// module chunks = 2